<template>
  <div id="dialog-loading">
    <img :src="`/gif/kickboard_hare.gif`"/>
    <div class="loading-text">Loading...</div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      openMenus: {}, // ✅ 별도의 객체로 메뉴 상태 관리
    };
  },
  methods: {
  },
  setup() {
  },
};
</script>

<style scoped>
#dialog-loading { 
  position: absolute;
  left:0;
  top:0;
  width: 100%;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background: var(--color-surface);
  backdrop-filter: blur(var(--effect-blur));
  color:var(--base-color);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

#dialog-loading > img {
  max-width: 480px;
  width: 50%;
  height: auto;
  aspect-ratio: 1/1;
  object-fit: cover;
  animation: loading 1s infinite linear;
}

#dialog-loading > .loading-text {
  font-size: var(--size-bigbig);
  font-weight: 600;
  color: var(--base-color);
  margin-top: var(--font-size-md);
}
</style>
